import { createAction, createSlice } from '@reduxjs/toolkit';


export type Blog = {
    link: string,
    title: string,
}


const initialState: Blog = {
    link: '',
    title: '',
};

export const revertAll = createAction('REVERT_ALL');

// Redux Toolkit slice
export const blogReducer: any = createSlice({
    name: 'blog',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setBlog: (state, action) => {
            return {
                ...action.payload
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(revertAll, () => initialState);
    },
});
export const { setBlog } = blogReducer.actions;
export default blogReducer;